import get from 'lodash/get.js'
import ShipperOptions from '@ordoro/shipper-options'

import {UPS} from '../common/constants/ShipperNames.js'

export default ShipperOptions

export const SHIPPER_NAMES_BY_TYPE = Object.keys(ShipperOptions).reduce(
  (prev, shipperType) => {
    const shipperOption = ShipperOptions[shipperType]

    prev[shipperType] = shipperOption.display_name

    return prev
  },
  {},
)

export function shipperOptionSelector(state, {shipperType}) {
  return ShipperOptions[shipperType]
}

export function shipperDisplayNameSelector(state, {shipperType}) {
  const shipperOption = shipperOptionSelector(state, {shipperType})

  return shipperOption ? shipperOption.display_name : shipperType
}

export function patchInNameUniqueness(options) {
  // This is because DHL duplicates their shipping method names
  const nameLookup = {}

  for (const option of options) {
    const names = nameLookup[option.display] || []

    names.push(option)

    nameLookup[option.display] = names
  }

  for (const list of Object.values(nameLookup)) {
    if (list.length > 1) {
      for (const option of list) {
        option.display = `${option.display} - ${option.value}`
      }
    }
  }

  return options
}

for (const set of Object.values(ShipperOptions)) {
  patchInNameUniqueness(set.shipping_method || [])
}

export function shippingMethodOptionsSelector(state, {shipperType}) {
  const shipperOption = shipperOptionSelector(state, {shipperType})

  if (!shipperOption) {
    return []
  }

  return shipperType === UPS
    ? [
        ...shipperOption.shipping_method,
        ...shipperOption.shipping_method_mail_innovations,
      ]
    : shipperOption.shipping_method
}

export function boxShapesSelector(state, {shipperType}) {
  const shipperOption = shipperOptionSelector(state, {shipperType})

  if (shipperType === UPS) {
    return [
      ...(shipperOption.box_shape_mail_innovations || []),
      ...(shipperOption.box_shape || []),
    ]
  }

  return shipperOption.box_shape || []
}

export function boxShapeOptionSelector(state, {shipperType, boxShape}) {
  const boxShapes = boxShapesSelector(state, {shipperType})

  return boxShapes.find(({value}) => value === boxShape)
}

export function boxShapeNameSelector(state, {shipperType, boxShape}) {
  return (
    get(boxShapeOptionSelector(state, {shipperType, boxShape}), 'display') ||
    boxShape
  )
}
